import script from "./TemplateCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateCenter.vue?vue&type=script&setup=true&lang=js"

import "./TemplateCenter.vue?vue&type=style&index=0&id=4ce22ecf&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ce22ecf"]])

export default __exports__